import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import StartChattingButton from './Button'
import PoweredByJibber from '/chat/src/components/PoweredByJibber';
import style from './style.scss';

class StartChattingBody extends Component {

    render(){
        return(
            <div className={style.Body}>
                <StartChattingButton/>
                <PoweredByJibber/>
            </div>
        )
    }
}

export default StartChattingBody



// WEBPACK FOOTER //
// ./routes/OfflineFormular/Body.js